import React, { Component } from 'react';
import { DISPATCH_ID } from '../libs/utils/Const';
import { connect } from 'react-redux';
import '../css/dataTables.css';
import $ from 'jquery';


class NotificationPointsCardModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeModalLastDate = async () => {
        const { cleanData } = this.props;
        $('#notificationPointsCard').modal('hide');
        cleanData();
    };

    closeAction = () => {
        const { cleanData } = this.props;
        $('#notificationPointsCard').on('hide.bs.modal', function () {
            cleanData();
        });
    };

    render() {
        const {
            headerDocument,
            relatedIncomingPayments,
            relatedDocs,
            cancelTimbra,
            // returnPointsCard,
            returnedPoints,
        } = this.props;

        let flagDevolutionPoints = false;
        if (headerDocument?.DocEntry && relatedDocs?.[0]?.DocEntry && headerDocument?.IsCancelCFDI === "Y" && relatedDocs?.[0]?.IsCancelCFDI === "Y") {
            flagDevolutionPoints = true;
        }
        return (

            <>
                <div className="modal fade bd-example-modal-xl modal-open scroll"
                    id="notificationPointsCard"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true">

                    <div className="modal-dialog modal-xl modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white"
                                style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">
                                    {!flagDevolutionPoints ? 'Estos documentos pertenecen a una venta con monedero electrónico y deben ser cancelados' : '¡Puntos devueltos con éxito!'}
                                </h4>
                                <button type="button" className="close" onClick={this.closeModalLastDate} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">
                                        &times;
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12" style={{ ppaddingLeft: 50, paddingRight: 50 }}>
                                            <div>
                                                <div className="row">
                                                    {relatedIncomingPayments?.isCanceledPayment &&
                                                        <p className="col-12 font-weight-bold text-danger text-center">
                                                            ⚠ El pago ya se ha cancelado correctamente. ⚠
                                                        </p>
                                                    }
                                                    {!flagDevolutionPoints &&
                                                        <p className="col-12 font-weight-bold text-danger text-center">
                                                            ⚠ {relatedIncomingPayments?.relatedPayments[0]?.DocNum ? 'Solo el pago puede cancelarse desde Counter.' : ''} Para cancelar facturas o notas de crédito, comunícate con el administrador. ⚠
                                                        </p>
                                                    }
                                                    {flagDevolutionPoints &&
                                                        <p className="col-12 font-weight-bold text-success text-center">
                                                            {/* <span role="img" aria-label="devolución">🔄</span> Los puntos de esta venta ya están disponibles para devolución. */}
                                                            🎉 ¡Felicidades! 🎉 <br />
                                                            🔄 Se te han devuelto <span className="text-primary">{returnedPoints}</span> puntos.
                                                            ¡Úsalos en tu próxima compra! 🛍️
                                                        </p>
                                                    }

                                                    <div className="col-12">
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">N° Factura:</span>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="txtDatePoints"
                                                                disabled="true"
                                                                value={headerDocument?.DocNum || ''}
                                                            />
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Folio:</span>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="txtDatePoints"
                                                                disabled="true"
                                                                value={headerDocument?.NumAtCard || ''}
                                                            />
                                                            {headerDocument?.IsCancelCFDI === 'Y' &&
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="txtDatePoints"
                                                                    disabled="true"
                                                                    value={'Timbre cancelado correctamente'}
                                                                />
                                                            }
                                                            {headerDocument?.CANCELED === 'N' &&
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="txtDatePoints"
                                                                    disabled="true"
                                                                    style={{ width: '190px' }}
                                                                    value={'⚠ SOLICITE LA CANCELACIÓN DEL DOCUMENTO ⚠'}
                                                                />
                                                            }
                                                            {headerDocument?.DocStatus === 'C' && headerDocument?.CANCELED === 'Y' && headerDocument?.IsCancelCFDI === 'N' &&
                                                                <button type="button" className="btn btn-danger text-white" onClick={() => cancelTimbra({ Table: 'OINV', info: headerDocument })} >Cancelar timbre</button>
                                                            }
                                                        </div>
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">N° Pago:</span>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="txtDatePoints"
                                                                disabled="true"
                                                                value={relatedIncomingPayments?.relatedPayments[0]?.DocNum || headerDocument?.ReceiptNum + ' El pago ya esta cancelado'}
                                                            />
                                                            {/* HACE FALTA LA FUNCION PARA CANCELAR EL PAGO DESDE AQUI */}
                                                            {/* {relatedIncomingPayments?.relatedPayments[0]?.DocNum &&
                                                                <button type="button" className="btn btn-danger text-white" onClick={this.closeModalLastDate} >Cancelar pago</button>
                                                            } */}
                                                        </div>
                                                        {relatedDocs.length > 0 && <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">N° Nota de crédito:</span>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="txtDatePoints"
                                                                disabled="true"
                                                                value={relatedDocs[0]?.DocNum || ''}
                                                            />
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Folio:</span>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="txtDatePoints"
                                                                disabled="true"
                                                                value={relatedDocs[0]?.NumAtCard || ''}
                                                            />
                                                            {relatedDocs[0]?.IsCancelCFDI === 'Y' &&
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="txtDatePoints"
                                                                    disabled="true"
                                                                    value={'Timbre cancelado correctamente'}
                                                                />
                                                            }
                                                            {relatedDocs[0]?.DocStatus === 'O' && relatedDocs[0]?.CANCELED === 'N' &&
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="txtDatePoints"
                                                                    disabled="true"
                                                                    style={{ width: '220px' }}
                                                                    value={'⚠ SOLICITE LA CANCELACIÓN DEL DOCUMENTO ⚠'}
                                                                />
                                                            }
                                                            {relatedDocs[0]?.DocStatus === 'C' && relatedDocs[0]?.CANCELED === 'Y' && relatedDocs[0]?.IsCancelCFDI === 'N' &&
                                                                <button type="button" className="btn btn-danger text-white" onClick={() => cancelTimbra({ Table: 'ORIN', info: relatedDocs[0] })} >Cancelar timbre</button>
                                                            }
                                                        </div>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                {/* {flagDevolutionPoints &&
                                    <button type="button" className="btn botonCorrect text-black" onClick={() => returnPointsCard(headerDocument)} >Devolver puntos</button>
                                } */}
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeModalLastDate} >Cerrar</button>
                                {/* <button type="button" className="btn botonCorrect text-black" onClick={activeShowAreYouAgreeModal_LastDate} >Guardar Cambios</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NotificationPointsCardModal);